import { Modal } from 'components/core';
import { notifyError } from 'config/setupBugsnag';
import getConfig from 'next/config';
import { FC, useEffect } from 'react';
import { useRetriveCart } from 'reactQuery/queries';
import { Styled, ThreeDSecurePaymentProps } from '.';

export const ThreeDSecurePayment: FC<ThreeDSecurePaymentProps> = ({
  creditCard,
  setOrderStep,
  setOrderFailure,
  set3DSModalOpen,
  placeOrderMutation,
}) => {
  const { data: currentCart } = useRetriveCart();

  const { publicRuntimeConfig } = getConfig();
  const payment3DSURL = publicRuntimeConfig.PAYMENTS_3DS_LINK;
  const appHost = publicRuntimeConfig.APP_HOST;

  const orderAmount = currentCart?.total;

  const cardNumber = creditCard?.json_data.ar_card_number;
  const customerCode = creditCard?.json_data.ar_customer_code;

  const returnUrl = appHost + '/cartview';

  const source = `${payment3DSURL}?access_token=${cardNumber}&amount=${orderAmount}&customer_code=${customerCode}&return_url=${returnUrl}`;

  useEffect(() => {
    const handle3DSCallback = (event: MessageEvent) => {
      console.log('handle3DSCallback response', event);
      const dataFromIframe = event.data; //event.data
      if (!creditCard) {
        return;
      }
      if (typeof dataFromIframe.pay_data === 'undefined') {
        return;
      }
      const secureCardData = creditCard.json_data as any;
      secureCardData.challengeResult = dataFromIframe.pay_data.challengeResult;
      secureCardData.paymentData = dataFromIframe.pay_data.paymentData;
      secureCardData.md = dataFromIframe.pay_data.md;
      secureCardData.paResponse = dataFromIframe.pay_data.paResponse;
      if (dataFromIframe.result == 'AuthenticationFinished') {
        const selectedCreditCard = creditCard;
        selectedCreditCard.json_data = secureCardData;
        placeOrderMutation.mutate({
          setOrderStep,
          selectedCreditCard,
          setOrderFailure,
        });
        set3DSModalOpen(false);
      } else {
        notifyError('3DS Authentication Failed', event);
        setOrderFailure('GENERIC_ORDER_ERROR');
        set3DSModalOpen(false);
      }
    };

    window.addEventListener('message', handle3DSCallback);
    return () => {
      window.removeEventListener('message', handle3DSCallback);
    };
  }, [creditCard]);

  return (
    <Modal overlaysize="medium">
      <Styled.ThreeDSecurePaymentModalContainer>
        <iframe id="iframe1" src={source} height="600px" width="600px"></iframe>
      </Styled.ThreeDSecurePaymentModalContainer>
    </Modal>
  );
};
